import "../styles/Sidebar.css";
import {
  FaBars,
  FaGear,
  FaMessage,
  FaMoneyCheckDollar,
  FaPhone,
  FaSkull,
  FaUsers,
} from "react-icons/fa6";
import { FaArrowRightFromBracket } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { LuMailWarning } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axiosInstance from "../api/axiosInstance";
import Button from "react-bootstrap/Button";
import Logo from "../assets/images/logo.jpeg";
import Offcanvas from "react-bootstrap/Offcanvas";
import toast from "react-hot-toast";

const options = [
  {
    backdrop: false,
    name: "Enable body scrolling",
    scroll: true,
  },
];

const navItemsAdmin = [
  {
    icon: FaUsers,
    link: "/",
    name: "Users",
  },
  {
    icon: LuMailWarning,
    link: "/spam",
    name: "Spam Words",
  },
  // {
  //   icon: FaSkull,
  //   link: "/twilio",
  //   name: "Developer Admin",
  // },
];

const navItemsUser = [
  {
    icon: FaMessage,
    link: "/",
    name: "Messages",
  },
  {
    icon: FaPhone,
    link: "/numbers",
    name: "Numbers",
  },
  {
    icon: FaMoneyCheckDollar,
    link: "/billing",
    name: "Billing",
  },
  {
    icon: FaGear,
    link: "/setting",
    name: "Settings",
  },
];

const Sidebar = ({ isNewUserAdded, setAuth }) => {
  const { user, token } = JSON.parse(localStorage.getItem("auth")) || {
    user: {},
  };
  const navigate = useNavigate();

  const [activeNav, setActiveNav] = useState(
    user.isAdmin ? "Users" : "Messages"
  );
  const [show, setShow] = useState(window.innerWidth >= 768);
  const [totalActiveNumbers, setTotalActiveNumbers] = useState(0);

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);

  const handleResize = () => {
    if (window.innerWidth >= 768) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("auth");
    setAuth(null);
    toast.success("Logged out successfully!");
    navigate("/login");
  };

  const refreshTotalNumbers = async () => {
    if (user.isAdmin) {
      try {
        const response = await axiosInstance.get("/user/totalActiveNumber", {
          headers: { authorization: token },
        });

        if (response?.data?.total) {
          setTotalActiveNumbers(response.data.total);
        } else {
          toast.error("Failed to fetch active numbers!");
        }
      } catch (error) {
        console.error("🚀 -> refreshTotalNumbers -> error:", error);
        toast.error("Failed to refresh active numbers!");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isNewUserAdded) refreshTotalNumbers();
  }, [isNewUserAdded]);

  return (
    <>
      <div className="mobile-top-nav">
        <Button onClick={toggleShow} className="me-2 navbar-toggler">
          <FaBars />
        </Button>
      </div>
      {options.map((props, idx) => (
        <Offcanvas
          {...props}
          className="siderbar"
          key={idx}
          onHide={handleClose}
          show={show}
        >
          <div className="d-xlg-none d-lg-none d-md-block d-block">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Dashboard</Offcanvas.Title>
            </Offcanvas.Header>
          </div>
          <Offcanvas.Body id="scrollbar_side">
            <nav className="nav-dark">
              <div id="sidebar_brand" className="d-lg-block d-none">
                <img alt="" src={Logo} />
              </div>
              <ul className="navbar-nav">
                {(user.isAdmin ? navItemsAdmin : navItemsUser).map(
                  (item, index) => {
                    const IconComponent = item.icon;
                    return (
                      <li key={index}>
                        <Link
                          className={`nav-link px-3 sidebar-link ${
                            activeNav === item.name ? "active" : ""
                          }`}
                          onClick={() => setActiveNav(item.name)}
                          role="button"
                          to={item.link}
                        >
                          <IconComponent className="me-3" />
                          <span>{item.name}</span>
                        </Link>
                      </li>
                    );
                  }
                )}
                <li>
                  <Link
                    className="nav-link px-3 sidebar-link"
                    onClick={handleLogout}
                  >
                    <FaArrowRightFromBracket className="me-3" />
                    <span>Logout</span>
                  </Link>
                </li>
              </ul>
              <div className="position-absolute bottom-0 start-0 w-100 px-3">
                <button className="activeNumBtn" type="button">
                  {user.isAdmin
                    ? totalActiveNumbers
                    : user?.assignNumber?.length || 0}{" "}
                  Active Numbers
                </button>
                <a
                  className="termsLink"
                  href="https://www.sms2u.io/tos"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>
              </div>
            </nav>
          </Offcanvas.Body>
        </Offcanvas>
      ))}
    </>
  );
};

export default Sidebar;
